<template>
  <v-layout>
    <app-loader
      v-if="!pageLoaded"
      title="Загрузка данных Складов вне Украины"
      :loading="!pageLoaded"
    />
    <v-container
      v-else
      class="d-flex justify-center"
      column
    >
      <v-card
        v-if="!noData"
        tile
        class="mt-0 mb-1 ml-0 pa-2 elevation-1"
        full-width
        :style="{
          height: `${blockHeight + 'px'}`,
          'overflow-y': 'auto'
        }"
      >
        <v-card-title>
          <h1 class="h3 mb-2">
            {{ title }}
          </h1>
        </v-card-title>

        <v-card-text>
          <v-row class="d-flex justify-center">
            <div>
              <v-img
                :src="`${$url}${posterPath}`"
              />
            </div>
          </v-row>
          <v-row>
            <span v-html="value" />
          </v-row>
        </v-card-text>
      </v-card>
      <v-card
        v-else
        tile
        class="mt-0 mb-1 ml-0 pa-2 elevation-1"
        full-width
        :style="{
          height: `${blockHeight + 'px'}`,
          'width': '100%',
          'overflow-y': 'auto'
        }"
      >
        <v-card-title><p>Нет данных о складах вне Украины</p></v-card-title>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import * as warehousesApi from "../../backend/warehousesApi";

export default {
  data() {
    return {
      title: "",
      value: "",
      posterPath: "",
      date: "",
      pageLoaded: false,
      noData: false,
    };
  },
  computed: {
    blockHeight() {
      return window.innerHeight - 220;
    },
  },
  async created() {
    const warehouse = await this.getWarehousesList();
    if (warehouse) {
      await this.getWarehouses(warehouse.link);
    } else {
      this.noData = true;
      this.pageLoaded = true;
    }
  },
  methods: {
    async getWarehousesList() {
      this.pageLoaded = false;
      const res = await warehousesApi.getWarehousesList();
      return res.result[0];
    },
    async getWarehouses(link) {
      const res = await warehousesApi.getWarehouses(link);
      this.title = res.title;
      this.value = res.value;
      this.posterPath = res.posterPath;
      this.date = res.createdAt;
      this.pageLoaded = true;
    },
  },
};
</script>
